import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import PrivateRoute from 'PrivateRoute'
import 'scss/App.scss';

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

// Containers
const DefaultLayout = React.lazy(() => import('containers/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('views/Login'));
const Register = React.lazy(() => import('./views/Register/Register'));
const RegisterSuccess = React.lazy(() => import('./views/Register/RegisterSuccess'));
const Page404 = React.lazy(() => import('views/Error/Page404'));
const Page500 = React.lazy(() => import('views/Error/Page500'));
const ForgotPassword = React.lazy(() => import('views/ForgotPassword/ForgotPassword'))
const ResetPassword = React.lazy(() => import('views/ForgotPassword/ResetPassword'))
const ForgotPasswordSuccess = React.lazy(() => import('views/ForgotPassword/ForgotPasswordSuccess'))

class App extends Component {

  render() {
    return (
      <React.Suspense fallback={loading()}>
        <Switch>
          <BrowserRouter basename='/ternak/'>
            <Route exact path="/404" name="Page 404" render={props => <Page404 {...props} />} />
            <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
            <Route
              exact
              path="/login"
              name="Login"
              render={props => <Login isAuthenticated={this.props.isAuthenticated} {...props} />} />

            <Route exact path="/register/success" name="Page Register Success" render={props => <RegisterSuccess {...props} />} />
            <Route exact path="/register" name="Page Register" render={props => <Register {...props} />} />

            <Route exact path="/forgot_password" name="Forgot Password" render={props => <ForgotPassword {...props} />} />
            <Route exact path="/reset_password/:token" name="Reset Password" render={props => <ResetPassword {...props} />} />
            <Route exact path="/forgot_password/success" name="Page Reset Password Success" render={props => <ForgotPasswordSuccess {...props} />} />

            <PrivateRoute
              path="/"
              name="Home"
              render={props => <DefaultLayout  {...props} />}
              isAuthenticated={this.props.isAuthenticated} />
          </BrowserRouter>
        </Switch>
      </React.Suspense>
    );
  }
}

App.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated
  }
}

export default withRouter(connect(mapStateToProps)(App))
